import React from 'react'
import { Alert, Icon, Link, ShowIf } from '@ztechapps/webui.util'
import { ForgotPassword, BasicLoginForm } from '@ztechapps/webui.auth'
import { Stack } from 'react-bootstrap'
import { appSettings } from '../../../config/app-settings'

export type BasicAuthLayoutProps = { initialAlertMessage?: string; alertType?: string }
export const BasicAuthLayout = ({ initialAlertMessage, alertType }: BasicAuthLayoutProps = {}) => {
  const [alertMessage] = React.useState(initialAlertMessage ?? null)
  const [isLoginScreen, setIsLoginScreen] = React.useState(true)
  const recaptchaSiteKey = appSettings?.Google?.recaptchaSiteKey

  alertType = alertType ?? 'success'

  //this should get the recaptcha token from here, that can be used for login, register and forgot password

  const forgotPasswordComponent = (
    <div className="my-3 d-flex justify-content-end">
      <Link
        onClick={() => {
          setIsLoginScreen(false)
        }}
      >
        Forgot your password?
      </Link>
    </div>
  )

  return (
    <div>
      <ShowIf condition={!!alertMessage}>
        <Alert type={alertType}>{alertMessage}</Alert>
      </ShowIf>

      <ShowIf condition={isLoginScreen}>
        <div className="p-sm">
          <BasicLoginForm
            formAction="/api/auth/basic"
            forgotPasswordComponent={forgotPasswordComponent}
            recaptchaSiteKey={recaptchaSiteKey}
          />
        </div>
      </ShowIf>
      <ShowIf condition={!isLoginScreen}>
        <Stack gap={2}>
          <ForgotPassword url="/api/auth/basic/forgot-password" recaptchaSiteKey={recaptchaSiteKey} />
          <div>
            <Link
              onClick={() => {
                setIsLoginScreen(true)
              }}
            >
              <Icon name="arrow-left" /> Back to login
            </Link>
          </div>
        </Stack>
      </ShowIf>
    </div>
  )
}
